/**
 * See https://digitickets.atlassian.net/browse/PROP-1251
 * Originally we thought there was a requirement to always print a VAT receipt if an order's total
 * was >£250. In the end we determiend this wasn't the case, but the code to handle that was already
 * written.
 * To avoid having to rip out a lot of code we will simply set the limit to infinity so that a VAT
 * receipt will never be required. In the future if we want to reintroduce the limit this will be easy to change back.
 *
 * @type {number}
 */
const vatThreshold = Infinity;

/**
 * @param {Cart} cart
 */
const cartExceedsVatThreshold = (cart) => {
    const total = cart.getTotal();

    return Math.abs(total) >= vatThreshold;
};

/**
 * @param {Order} order
 */
const orderExceedsVatThreshold = (order) => {
    const total = order.getTotal();

    return Math.abs(total) >= vatThreshold;
};

/**
 * Supply the `bookingTotals` property returned by the API
 * and this method will tell you if the order ever exceeded the limit for which
 * a VAT receipt is mandatory.
 *
 * @param {{runningTotal:Number}[]} bookingTotals
 * @return {boolean}
 */
const bookingExceededVatThreshold = (bookingTotals) => {
    for (let i = 0; i < bookingTotals.length; i++) {
        if (Math.abs(bookingTotals[i].runningTotal) >= vatThreshold) {
            return true;
        }
    }

    return false;
};

module.exports = {
    bookingExceededVatThreshold,
    cartExceedsVatThreshold,
    orderExceedsVatThreshold,
};
